import React, { Component } from "react";
import PropTypes from "prop-types";
import DetailsCard from "~/scripts/components/DetailsCard";

class ContactsList extends Component {
    static propTypes = {
        contacts: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                role: PropTypes.string,
                phoneNumber: PropTypes.string,
                emailAddress: PropTypes.string
            })
        )
    };

    renderContact = contact => {
        const { name, role, phoneNumber, emailAddress } = contact;

        const items = [
            {
                text: name
            },
            {
                text: role
            },
            {
                text: phoneNumber,
                href: `tel:${phoneNumber}`
            },
            {
                text: emailAddress,
                href: `mailto:${emailAddress}`
            }
        ];

        return <DetailsCard key={name} items={items} />;
    };

    render() {
        const { contacts } = this.props;

        if (!contacts) {
            return null;
        }

        return (
            <div className="contacts-list">
                <div className="contacts-list__contact">
                    <div className="contacts-list__columns">
                        {contacts.map(this.renderContact)}
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactsList;



// WEBPACK FOOTER //
// ./src/scripts/components/ContactsList.js